import faker from 'faker';
import fakeRequest from '../utils/fakeRequest';
import { reject } from 'lodash';
import mock from '../utils/mock';
import { getBase64FromFile, getBase64FromUrl } from 'src/utils/convertBase64';
import PDF_TEMPLATE from '../components/management/integrated-reports/report-create/pdf-viewer/ESG_Report.pdf';

// const INTEGRATED_REPORTS = [
//   {
//     id: 1,
//     title: 'Energy Management',
//     frameWork: 'GRI Standard',
//     reportPeriod: '2021',
//     createdBy: 'Jaydon Smith',
//     report: {
//       title: 'Energy Management',
//       period: {
//         label: '2021',
//         start: '2021-01-01',
//         end: '2021-12-31'
//       },
//       introducion: {
//         body: '',
//         reviewComment: {
//           reviewer: 0,
//           body: ''
//         }
//       },
//       reviewComment: {
//         reviewer: 0,
//         body: ''
//       },
//       topics: [
//         {
//           name: 'Universal',
//           standards: [
//             {
//               id: '2',
//               name: 'GRI 2: General Disclosures',
//               disclosures: [
//                 {
//                   id: '2-1',
//                   name: 'GRI 2-1: Organisational details',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '2-1-a',
//                       name: 'a. report its legal name',
//                       title: "Report it's Legal Name",
//                       guidance:
//                         'Guidance to 2-1-a If the organization uses a commonly known trading name or business name that is different from its legal name, it should report this in addition to its legal name.',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: 'ssm',
//                         path: '/experienz/prod/${domain}/title'
//                       }
//                     },
//                     {
//                       id: '2-1-b',
//                       name: 'b. report its nature of ownership and legal form',
//                       guidance: 'Guidance to 2-1-b ...',
//                       body: null,
//                       dataType: 'image',
//                       source: {
//                         id: 'cube-chart',
//                         chartQuery:
//                           '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
//                       }
//                     },
//                     {
//                       id: '2-1-c',
//                       name: 'c. report the location of its headquarters',
//                       guidance: 'Guidance to 2-1-c ...',
//                       body: null,
//                       dataType: 'table',
//                       source: {
//                         id: 'cube-table',
//                         chartQuery:
//                           '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
//                       }
//                     },
//                     {
//                       id: '2-1-d',
//                       name: 'd. report its countries of operation.',
//                       guidance: 'Guidance to 2-1-d ...',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: '...'
//                       }
//                     },
//                     {
//                       id: '2-1-e',
//                       name: 'd. ...',
//                       guidance: 'Guidance to 2-1-e ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           name: 'Environment',
//           standards: []
//         },
//         {
//           name: 'Social',
//           standards: []
//         },
//         {
//           name: 'Economic',
//           standards: [
//             {
//               id: '401',
//               name: 'GRI 401: Employment 2016',
//               disclosures: [
//                 {
//                   id: '401-1',
//                   name:
//                     '401-1: Explanation of the material topic and its Boundary',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '401-1-a',
//                       name: 'a: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-a ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     },
//                     {
//                       id: '401-1-b',
//                       name: 'b: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-b ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     reportStatus: 'Pending Approval',
//     auditHistory: [
//       {
//         date: '2021-08-01 13:25',
//         action: 'create',
//         user: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-03-01 17:25',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-03-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-04-01 17:27',
//         action: 'rejected',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2021-05-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-06-01 17:26',
//         action: 'approve',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2021-07-01 17:26',
//         action: 'download',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-08-01 17:27',
//         action: 'download',
//         userId: { id: 12, name: 'James Franco' }
//       }
//     ]
//   },
//   {
//     id: 2,
//     title: 'Diversity',
//     frameWork: 'TCFD',
//     reportPeriod: 'Q1 2022',
//     createdBy: 'Ashini Martin',
//     report: {
//       title: 'Diversity',
//       period: {
//         label: 'Q1 2022',
//         start: '2022-01-01',
//         end: '2022-03-30'
//       },
//       introducion: {
//         body: '',
//         reviewComment: {
//           reviewer: 0,
//           body: ''
//         }
//       },
//       reviewComment: {
//         reviewer: 0,
//         body: ''
//       },
//       topics: [
//         {
//           name: 'Universal',
//           standards: [
//             {
//               id: '2',
//               name: 'GRI 2: General Disclosures',
//               disclosures: [
//                 {
//                   id: '2-1',
//                   name: 'GRI 2-1: Organisational details',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '2-1-a',
//                       name: 'a. report its legal name',
//                       title: "Report it's Legal Name",
//                       guidance:
//                         'Guidance to 2-1-a If the organization uses a commonly known trading name or business name that is different from its legal name, it should report this in addition to its legal name.',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: 'ssm',
//                         path: '/experienz/prod/${domain}/title'
//                       }
//                     },
//                     {
//                       id: '2-1-b',
//                       name: 'b. report its nature of ownership and legal form',
//                       guidance: 'Guidance to 2-1-b ...',
//                       body: null,
//                       dataType: 'image',
//                       source: {
//                         id: 'cube-chart',
//                         chartQuery:
//                           '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
//                       }
//                     },
//                     {
//                       id: '2-1-c',
//                       name: 'c. report the location of its headquarters',
//                       guidance: 'Guidance to 2-1-c ...',
//                       body: null,
//                       dataType: 'table',
//                       source: {
//                         id: 'cube-table',
//                         chartQuery:
//                           '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
//                       }
//                     },
//                     {
//                       id: '2-1-d',
//                       name: 'd. report its countries of operation.',
//                       guidance: 'Guidance to 2-1-d ...',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: '...'
//                       }
//                     },
//                     {
//                       id: '2-1-e',
//                       name: 'd. ...',
//                       guidance: 'Guidance to 2-1-e ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           name: 'Environment',
//           standards: []
//         },
//         {
//           name: 'Social',
//           standards: []
//         },
//         {
//           name: 'Economic',
//           standards: [
//             {
//               id: '401',
//               name: 'GRI 401: Employment 2016',
//               disclosures: [
//                 {
//                   id: '401-1',
//                   name:
//                     '401-1: Explanation of the material topic and its Boundary',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '401-1-a',
//                       name: 'a: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-a ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     },
//                     {
//                       id: '401-1-b',
//                       name: 'b: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-b ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     reportStatus: 'Approved',
//     auditHistory: [
//       {
//         date: '2022-01-01 13:25',
//         action: 'create',
//         user: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2022-01-01 17:25',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2022-02-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2022-02-03 17:27',
//         action: 'rejected',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2022-02-08 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2022-02-09 17:26',
//         action: 'approve',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2022-02-10 17:26',
//         action: 'download',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2022-02-10 17:27',
//         action: 'download',
//         userId: { id: 12, name: 'James Franco' }
//       }
//     ]
//   },
//   {
//     id: 3,
//     title: 'Work Experience',
//     frameWork: 'Experienz Summary',
//     reportPeriod: 'Q2 2022',
//     createdBy: 'Ashini Martin',
//     report: {
//       title: 'Work Experience',
//       period: {
//         label: 'Q2 2022',
//         start: '2022-04-01',
//         end: '2022-06-30'
//       },
//       introducion: {
//         body: '',
//         reviewComment: {
//           reviewer: 0,
//           body: ''
//         }
//       },
//       reviewComment: {
//         reviewer: 0,
//         body: ''
//       },
//       topics: [
//         {
//           name: 'Universal',
//           standards: [
//             {
//               id: '2',
//               name: 'GRI 2: General Disclosures',
//               disclosures: [
//                 {
//                   id: '2-1',
//                   name: 'GRI 2-1: Organisational details',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '2-1-a',
//                       name: 'a. report its legal name',
//                       title: "Report it's Legal Name",
//                       guidance:
//                         'Guidance to 2-1-a If the organization uses a commonly known trading name or business name that is different from its legal name, it should report this in addition to its legal name.',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: 'ssm',
//                         path: '/experienz/prod/${domain}/title'
//                       }
//                     },
//                     {
//                       id: '2-1-b',
//                       name: 'b. report its nature of ownership and legal form',
//                       guidance: 'Guidance to 2-1-b ...',
//                       body: null,
//                       dataType: 'image',
//                       source: {
//                         id: 'cube-chart',
//                         chartQuery:
//                           '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
//                       }
//                     },
//                     {
//                       id: '2-1-c',
//                       name: 'c. report the location of its headquarters',
//                       guidance: 'Guidance to 2-1-c ...',
//                       body: null,
//                       dataType: 'table',
//                       source: {
//                         id: 'cube-table',
//                         chartQuery:
//                           '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
//                       }
//                     },
//                     {
//                       id: '2-1-d',
//                       name: 'd. report its countries of operation.',
//                       guidance: 'Guidance to 2-1-d ...',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: '...'
//                       }
//                     },
//                     {
//                       id: '2-1-e',
//                       name: 'd. ...',
//                       guidance: 'Guidance to 2-1-e ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           name: 'Environment',
//           standards: []
//         },
//         {
//           name: 'Social',
//           standards: []
//         },
//         {
//           name: 'Economic',
//           standards: [
//             {
//               id: '401',
//               name: 'GRI 401: Employment 2016',
//               disclosures: [
//                 {
//                   id: '401-1',
//                   name:
//                     '401-1: Explanation of the material topic and its Boundary',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '401-1-a',
//                       name: 'a: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-a ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     },
//                     {
//                       id: '401-1-b',
//                       name: 'b: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-b ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     reportStatus: 'Saved',
//     auditHistory: [
//       {
//         date: '2022-04-01 13:25',
//         action: 'create',
//         user: { id: 11, name: 'Jaydon Smith' }
//       },
//       {
//         date: '2021-04-01 17:25',
//         action: 'modify',
//         userId: { id: 11, name: 'Jaydon Smith' }
//       },

//       {
//         date: '2021-04-04 17:27',
//         action: 'rejected',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2022-05-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2022-06-01 17:26',
//         action: 'approve',
//         userId: { id: 12, name: 'James Franco' }
//       }
//     ]
//   },
//   {
//     id: 4,
//     title: 'ESG Performance',
//     frameWork: 'TCFD',
//     reportPeriod: '2021',
//     createdBy: 'Ashini Martin',
//     report: {
//       title: 'ESG Performance',
//       period: {
//         label: '2021',
//         start: '2021-01-01',
//         end: '2021-12-31'
//       },
//       introducion: {
//         body: '',
//         reviewComment: {
//           reviewer: 0,
//           body: ''
//         }
//       },
//       reviewComment: {
//         reviewer: 0,
//         body: ''
//       },
//       topics: [
//         {
//           name: 'Universal',
//           standards: [
//             {
//               id: '2',
//               name: 'GRI 2: General Disclosures',
//               disclosures: [
//                 {
//                   id: '2-1',
//                   name: 'GRI 2-1: Organisational details',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '2-1-a',
//                       name: 'a. report its legal name',
//                       title: "Report it's Legal Name",
//                       guidance:
//                         'Guidance to 2-1-a If the organization uses a commonly known trading name or business name that is different from its legal name, it should report this in addition to its legal name.',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: 'ssm',
//                         path: '/experienz/prod/${domain}/title'
//                       }
//                     },
//                     {
//                       id: '2-1-b',
//                       name: 'b. report its nature of ownership and legal form',
//                       guidance: 'Guidance to 2-1-b ...',
//                       body: null,
//                       dataType: 'image',
//                       source: {
//                         id: 'cube-chart',
//                         chartQuery:
//                           '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
//                       }
//                     },
//                     {
//                       id: '2-1-c',
//                       name: 'c. report the location of its headquarters',
//                       guidance: 'Guidance to 2-1-c ...',
//                       body: null,
//                       dataType: 'table',
//                       source: {
//                         id: 'cube-table',
//                         chartQuery:
//                           '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
//                       }
//                     },
//                     {
//                       id: '2-1-d',
//                       name: 'd. report its countries of operation.',
//                       guidance: 'Guidance to 2-1-d ...',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: '...'
//                       }
//                     },
//                     {
//                       id: '2-1-e',
//                       name: 'd. ...',
//                       guidance: 'Guidance to 2-1-e ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           name: 'Environment',
//           standards: []
//         },
//         {
//           name: 'Social',
//           standards: []
//         },
//         {
//           name: 'Economic',
//           standards: [
//             {
//               id: '401',
//               name: 'GRI 401: Employment 2016',
//               disclosures: [
//                 {
//                   id: '401-1',
//                   name:
//                     '401-1: Explanation of the material topic and its Boundary',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '401-1-a',
//                       name: 'a: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-a ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     },
//                     {
//                       id: '401-1-b',
//                       name: 'b: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-b ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     reportStatus: 'Pending Approval',
//     auditHistory: [
//       {
//         date: '2021-08-01 13:25',
//         action: 'create',
//         user: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-03-01 17:25',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-03-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-04-01 17:27',
//         action: 'rejected',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2021-05-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-06-01 17:26',
//         action: 'approve',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2021-07-01 17:26',
//         action: 'download',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-08-01 17:27',
//         action: 'download',
//         userId: { id: 12, name: 'James Franco' }
//       }
//     ]
//   },
//   {
//     id: 5,
//     title: 'ESG Performance',
//     frameWork: 'TCFD',
//     reportPeriod: '2021',
//     createdBy: 'Ashini Martin',
//     report: {
//       title: 'ESG Performance',
//       period: {
//         label: '2021',
//         start: '2021-01-01',
//         end: '2021-12-31'
//       },
//       introducion: {
//         body: '',
//         reviewComment: {
//           reviewer: 0,
//           body: ''
//         }
//       },
//       reviewComment: {
//         reviewer: 0,
//         body: ''
//       },
//       topics: [
//         {
//           name: 'Universal',
//           standards: [
//             {
//               id: '2',
//               name: 'GRI 2: General Disclosures',
//               disclosures: [
//                 {
//                   id: '2-1',
//                   name: 'GRI 2-1: Organisational details',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '2-1-a',
//                       name: 'a. report its legal name',
//                       title: "Report it's Legal Name",
//                       guidance:
//                         'Guidance to 2-1-a If the organization uses a commonly known trading name or business name that is different from its legal name, it should report this in addition to its legal name.',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: 'ssm',
//                         path: '/experienz/prod/${domain}/title'
//                       }
//                     },
//                     {
//                       id: '2-1-b',
//                       name: 'b. report its nature of ownership and legal form',
//                       guidance: 'Guidance to 2-1-b ...',
//                       body: null,
//                       dataType: 'image',
//                       source: {
//                         id: 'cube-chart',
//                         chartQuery:
//                           '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
//                       }
//                     },
//                     {
//                       id: '2-1-c',
//                       name: 'c. report the location of its headquarters',
//                       guidance: 'Guidance to 2-1-c ...',
//                       body: null,
//                       dataType: 'table',
//                       source: {
//                         id: 'cube-table',
//                         chartQuery:
//                           '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
//                       }
//                     },
//                     {
//                       id: '2-1-d',
//                       name: 'd. report its countries of operation.',
//                       guidance: 'Guidance to 2-1-d ...',
//                       body: null,
//                       dataType: 'text',
//                       source: {
//                         id: '...'
//                       }
//                     },
//                     {
//                       id: '2-1-e',
//                       name: 'd. ...',
//                       guidance: 'Guidance to 2-1-e ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           name: 'Environment',
//           standards: []
//         },
//         {
//           name: 'Social',
//           standards: []
//         },
//         {
//           name: 'Economic',
//           standards: [
//             {
//               id: '401',
//               name: 'GRI 401: Employment 2016',
//               disclosures: [
//                 {
//                   id: '401-1',
//                   name:
//                     '401-1: Explanation of the material topic and its Boundary',
//                   selected: true,
//                   requirements: [
//                     {
//                       id: '401-1-a',
//                       name: 'a: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-a ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     },
//                     {
//                       id: '401-1-b',
//                       name: 'b: An explanation of why the topic is material.',
//                       guidance: 'Guidance to 401-1-b ...',
//                       body: 'Some default value',
//                       dataType: 'text',
//                       source: null
//                     }
//                   ]
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     reportStatus: 'Improvements Needed',
//     auditHistory: [
//       {
//         date: '2021-08-01 13:25',
//         action: 'create',
//         user: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-03-01 17:25',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-03-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-04-01 17:27',
//         action: 'rejected',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2021-05-01 17:26',
//         action: 'modify',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-06-01 17:26',
//         action: 'approve',
//         userId: { id: 12, name: 'James Franco' }
//       },
//       {
//         date: '2021-07-01 17:26',
//         action: 'download',
//         userId: { id: 10, name: 'Ashini Martin' }
//       },
//       {
//         date: '2021-08-01 17:27',
//         action: 'download',
//         userId: { id: 12, name: 'James Franco' }
//       }
//     ]
//   }
// ];

const INTEGRATED_REPORTS = [
  {
    id: 1,
    frameworkId: 1,
    name: 'Energy Management',
    frameWork: 'GRI Standard',
    period: '2021',
    createdBy: 'Ashini Martin',
    status: 1,
    isEditable: false,
    auditHistory: [
      {
        id: 1,
        date: '2021-08-01 13:25',
        action: 'create',
        name: 'Ashini Martin'
      },
      {
        id: 2,
        date: '2021-03-01 17:25',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 3,
        date: '2021-03-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 4,
        date: '2021-04-01 17:27',
        action: 'reject',
        name: 'James Franco'
      },
      {
        id: 5,
        date: '2021-05-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 6,
        date: '2021-06-01 17:26',
        action: 'approve',
        name: 'James Franco'
      },
      {
        id: 7,
        date: '2021-07-01 17:26',
        action: 'download',
        name: 'Ashini Martin'
      },
      {
        id: 8,
        date: '2021-08-01 17:27',
        action: 'download',
        name: 'James Franco'
      }
    ]
  },
  {
    id: 2,
    frameworkId: 1,
    name: 'Diversity',
    frameWork: 'TCFD',
    period: 'Q1 2022',
    createdBy: 'Jaydon Smith',
    status: 3,
    isEditable: true,
    auditHistory: [
      {
        id: 1,
        date: '2022-01-01 13:25',
        action: 'create',
        name: 'Ashini Martin'
      },
      {
        id: 2,
        date: '2022-01-01 17:25',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 3,
        date: '2022-02-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 4,
        date: '2022-02-03 17:27',
        action: 'reject',
        name: 'James Franco'
      },
      {
        id: 5,
        date: '2022-02-08 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 6,
        date: '2022-02-09 17:26',
        action: 'approve',
        name: 'James Franco'
      },
      {
        id: 7,
        date: '2022-02-10 17:26',
        action: 'download',
        name: 'Ashini Martin'
      },
      {
        id: 8,
        date: '2022-02-10 17:27',
        action: 'download',
        name: 'James Franco'
      }
    ]
  },
  {
    id: 3,
    frameworkId: 1,
    frameworkId: 1,
    name: 'Work Experience',
    frameWork: 'Experienz Summary',
    period: 'Q2 2022',
    createdBy: 'Jaydon Smith',
    status: 0,
    isEditable: true,
    auditHistory: [
      {
        id: 1,
        date: '2022-04-01 13:25',
        action: 'create',
        name: 'Jaydon Smith'
      },
      {
        id: 2,
        date: '2021-04-01 17:25',
        action: 'modify',
        name: 'Jaydon Smith'
      },

      {
        id: 3,
        date: '2021-04-04 17:27',
        action: 'reject',
        name: 'James Franco'
      },
      {
        id: 4,
        date: '2022-05-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 5,
        date: '2022-06-01 17:26',
        action: 'approve',
        name: 'James Franco'
      }
    ]
  },
  {
    id: 4,
    frameworkId: 1,
    name: 'ESG Performance',
    frameWork: 'TCFD',
    period: '2021',
    createdBy: 'Jaydon Smith',
    status: 4,
    isEditable: true,
    auditHistory: [
      {
        id: 1,
        date: '2021-08-01 13:25',
        action: 'create',
        name: 'Ashini Martin'
      },
      {
        id: 2,
        date: '2021-03-01 17:25',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 3,
        date: '2021-03-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 4,
        date: '2021-04-01 17:27',
        action: 'reject',
        name: 'James Franco'
      },
      {
        id: 5,
        date: '2021-05-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 6,
        date: '2021-06-01 17:26',
        action: 'approve',
        name: 'James Franco'
      },
      {
        id: 7,
        date: '2021-07-01 17:26',
        action: 'download',
        name: 'Ashini Martin'
      },
      {
        id: 8,
        date: '2021-08-01 17:27',
        action: 'download',
        name: 'James Franco'
      }
    ]
  },
  {
    id: 5,
    frameworkId: 1,
    name: 'ESG Performance',
    frameWork: 'TCFD',
    period: '2021',
    createdBy: 'Jaydon Smith',
    status: 2,
    isEditable: true,
    auditHistory: [
      {
        id: 1,
        date: '2021-08-01 13:25',
        action: 'create',
        name: 'Ashini Martin'
      },
      {
        id: 2,
        date: '2021-03-01 17:25',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 3,
        date: '2021-03-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 4,
        date: '2021-04-01 17:27',
        action: 'reject',
        name: 'James Franco'
      },
      {
        id: 5,
        date: '2021-05-01 17:26',
        action: 'modify',
        name: 'Ashini Martin'
      },
      {
        id: 6,
        date: '2021-06-01 17:26',
        action: 'approve',
        name: 'James Franco'
      },
      {
        id: 7,
        date: '2021-07-01 17:26',
        action: 'download',
        name: 'Ashini Martin'
      },
      {
        id: 8,
        date: '2021-08-01 17:27',
        action: 'download',
        name: 'James Franco'
      }
    ]
  }
];

const INTEGRATED_REPORT = [
  {
    id: 1,
    reportName: 'Energy Management',
    frameworkId: 1,
    frameWork: 'GRI Standard',
    reportPeriod: '2021',
    reportStatus: 1,
    period: {
      label: 'Last year',
      start: '2021-01-01',
      end: '2021-12-31'
    },
    introduction: {
      body:
        '<h4><strong>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</strong></h4><p><br></p><p>Mel te maiorum forensibus, odio ubique oblique vim et, enim debet cum ex. Vel melius necessitatibus et, ex ius modo doctus. Brute autem patrioque pro ea. Possit vocibus probatus mel ut, his ea causae epicuri. No harum tibique convenire sea. Decore dolores cu vix, ludus primis eu nam, agam esse ut pro. Eos ex postea torquatos, id nam dicunt reprehendunt.</p><p><br></p><ul><li>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei dictas aliquam salutatus.</li></ul><p><br></p><ul><li><em>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</em></li></ul><p><br></p><ul><li><em>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</em></li></ul><p><br></p><p><u>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</u></p><p><br></p><p>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei <strong><em><u>dictas aliquam salutatus.</u></em></strong></p><p><br></p><ol><li>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</li></ol><p><br></p><ol><li>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</li></ol>',
      reviewComments: [
        {
          reviewer: 0,
          body:
            '<p>There are some typos on line 3. Please correct them. Do not go into too much detail. Try to keep it simple.</P>',
          date: '10 Jul 2022 12:20 PM'
        },
        {
          reviewer: 0,
          body: '<p>Good job overall !</P>',
          date: '12 Jul 2022 09:10 AM'
        }
      ]
    },
    topics: [
      'a698f8a6-2597-4a9e-9d44-ee5cb5e27689',
      '8ace3c40-34a2-45bc-96a4-657d03cec235',
      '34aa1b04-2c38-4fe8-acb8-538a44156949'
    ],
    standards: [
      '397f4474-8270-4aad-afb4-f2ddea3a163c',
      'ae378063-bcb2-4248-8c27-61d76776cc64'
    ],
    requirements: [
      {
        key: '67aaeac0-d560-4816-b0c9-921aeb4e9e67',
        value: 'experienz'
      },
      {
        key: '99c31953-506a-4522-9d8e-17565c5dab89',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p>'
      },
      {
        key: '470f3049-5857-4be1-94f1-c8119d38af60',
        value: '<p>England, Sri Lanka, USA, Australia</p>'
      },
      {
        key: '5106e820-c639-4d0f-83f9-0bdae5fd28a6',
        value: '<p>London, UK</p>'
      },
      {
        key: '2295a0a8-1da5-4cb3-b497-d4d3a7788a4e',
        value:
          '<p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '7ef58cda-c7f4-4ed6-88e8-16e9fd49995c',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: 'f91fb6cf-d985-465c-9472-a5b00209ec87',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '4fb96f49-ca72-4e3e-939c-2489eb7467b0',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '62d29f51-3ac9-4115-862d-5a12bcbfb877',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '11faa601-eba6-4218-84da-ed30f8397362',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '486f7e0b-70be-4b62-a1ea-3b4e71d078d8',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      }
    ],
    modifiedRequirements: [
      '67aaeac0-d560-4816-b0c9-921aeb4e9e67',
      '470f3049-5857-4be1-94f1-c8119d38af60'
    ],
    reviewComments: [
      {
        reviewer: 0,
        body:
          '<p><strong>GRI 2-1 a  </strong>For the legal name, change it to experienz Ltd.</P> <p><strong>GRI 2-1 b  </strong>Please include more detail.</p> <p><strong>GRI 2-1 d  </strong>Add Singappore as a country of operation.</p>',
        date: '20 Aug 2022 03:20 PM'
      }
    ],
    reviewers: [
      {
        id: 2,
        name: 'Ashton Lewis'
      }
    ]
  },
  {
    id: 3,
    reportName: 'Work Experience',
    frameworkId: 1,
    frameWork: 'GRI Standard',
    reportPeriod: 'Q2 2022',
    reportStatus: 0,
    period: {
      label: 'Last quarter',
      start: '2022-04-01',
      end: '2022-06-31'
    },
    introduction: {
      body:
        '<h4><strong>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</strong></h4><p><br></p><p>Mel te maiorum forensibus, odio ubique oblique vim et, enim debet cum ex. Vel melius necessitatibus et, ex ius modo doctus. Brute autem patrioque pro ea. Possit vocibus probatus mel ut, his ea causae epicuri. No harum tibique convenire sea. Decore dolores cu vix, ludus primis eu nam, agam esse ut pro. Eos ex postea torquatos, id nam dicunt reprehendunt.</p><p><br></p><ul><li>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei dictas aliquam salutatus.</li></ul><p><br></p><ul><li><em>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</em></li></ul><p><br></p><ul><li><em>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</em></li></ul><p><br></p><p><u>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</u></p><p><br></p><p>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei <strong><em><u>dictas aliquam salutatus.</u></em></strong></p><p><br></p><ol><li>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</li></ol><p><br></p><ol><li>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</li></ol>',
      reviewComments: []
    },
    topics: [
      'a698f8a6-2597-4a9e-9d44-ee5cb5e27689',
      '8ace3c40-34a2-45bc-96a4-657d03cec235',
      '34aa1b04-2c38-4fe8-acb8-538a44156949'
    ],
    standards: [
      '397f4474-8270-4aad-afb4-f2ddea3a163c',
      'ae378063-bcb2-4248-8c27-61d76776cc64'
    ],
    requirements: [
      {
        key: '67aaeac0-d560-4816-b0c9-921aeb4e9e67',
        value: 'experienz'
      },
      {
        key: '99c31953-506a-4522-9d8e-17565c5dab89',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p>'
      },
      {
        key: '470f3049-5857-4be1-94f1-c8119d38af60',
        value: '<p>England, Sri Lanka, USA, Australia</p>'
      },
      {
        key: '5106e820-c639-4d0f-83f9-0bdae5fd28a6',
        value: '<p>London, UK</p>'
      },
      {
        key: '2295a0a8-1da5-4cb3-b497-d4d3a7788a4e',
        value:
          '<p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '7ef58cda-c7f4-4ed6-88e8-16e9fd49995c',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: 'f91fb6cf-d985-465c-9472-a5b00209ec87',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '4fb96f49-ca72-4e3e-939c-2489eb7467b0',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '62d29f51-3ac9-4115-862d-5a12bcbfb877',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '11faa601-eba6-4218-84da-ed30f8397362',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '486f7e0b-70be-4b62-a1ea-3b4e71d078d8',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      }
    ],
    modifiedRequirements: [],
    reviewComments: [],
    reviewers: [
      {
        id: 2,
        name: 'Ashton Lewis'
      }
    ]
  },
  {
    id: 5,
    reportName: 'ESG Performance',
    frameworkId: 1,
    frameWork: 'GRI Standard',
    reportPeriod: '2021',
    reportStatus: 2,
    period: {
      label: 'Last year',
      start: '2021-01-01',
      end: '2021-12-31'
    },
    introduction: {
      body:
        '<h4><strong>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</strong></h4><p><br></p><p>Mel te maiorum forensibus, odio ubique oblique vim et, enim debet cum ex. Vel melius necessitatibus et, ex ius modo doctus. Brute autem patrioque pro ea. Possit vocibus probatus mel ut, his ea causae epicuri. No harum tibique convenire sea. Decore dolores cu vix, ludus primis eu nam, agam esse ut pro. Eos ex postea torquatos, id nam dicunt reprehendunt.</p><p><br></p><ul><li>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei dictas aliquam salutatus.</li></ul><p><br></p><ul><li><em>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</em></li></ul><p><br></p><ul><li><em>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</em></li></ul><p><br></p><p><u>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</u></p><p><br></p><p>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei <strong><em><u>dictas aliquam salutatus.</u></em></strong></p><p><br></p><ol><li>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</li></ol><p><br></p><ol><li>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</li></ol>',
      reviewComments: [
        {
          reviewer: 0,
          body:
            '<p>There are some typos on line 3. Please correct them. Do not go into too much detail. Try to keep it simple.</P>',
          date: '10 Jul 2022 12:20 PM'
        },
        {
          reviewer: 0,
          body: '<p>Good job overall !</P>',
          date: '12 Jul 2022 09:10 AM'
        }
      ]
    },
    topics: [
      'a698f8a6-2597-4a9e-9d44-ee5cb5e27689',
      '8ace3c40-34a2-45bc-96a4-657d03cec235',
      '34aa1b04-2c38-4fe8-acb8-538a44156949'
    ],
    standards: [
      '397f4474-8270-4aad-afb4-f2ddea3a163c',
      'ae378063-bcb2-4248-8c27-61d76776cc64'
    ],
    requirements: [
      {
        key: '67aaeac0-d560-4816-b0c9-921aeb4e9e67',
        value: 'experienz'
      },
      {
        key: '99c31953-506a-4522-9d8e-17565c5dab89',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p>'
      },
      {
        key: '470f3049-5857-4be1-94f1-c8119d38af60',
        value: '<p>England, Sri Lanka, USA, Australia</p>'
      },
      {
        key: '5106e820-c639-4d0f-83f9-0bdae5fd28a6',
        value: '<p>London, UK</p>'
      },
      {
        key: '2295a0a8-1da5-4cb3-b497-d4d3a7788a4e',
        value:
          '<p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '7ef58cda-c7f4-4ed6-88e8-16e9fd49995c',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: 'f91fb6cf-d985-465c-9472-a5b00209ec87',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '4fb96f49-ca72-4e3e-939c-2489eb7467b0',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '62d29f51-3ac9-4115-862d-5a12bcbfb877',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '11faa601-eba6-4218-84da-ed30f8397362',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '486f7e0b-70be-4b62-a1ea-3b4e71d078d8',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      }
    ],
    modifiedRequirements: [],
    reviewComments: [
      {
        reviewer: 0,
        body:
          '<p><strong>GRI 2-1 a  </strong>For the legal name, change it to experienz Ltd.</P> <p><strong>GRI 2-1 b  </strong>Please include more detail.</p> <p><strong>GRI 2-1 d  </strong>Add Singappore as a country of operation.</p>',
        date: '20 Aug 2022 03:20 PM'
      }
    ],
    reviewers: [
      {
        id: 2,
        name: 'Ashton Lewis'
      }
    ]
  },
  {
    id: 2,
    reportName: 'Diversity',
    frameworkId: 1,
    frameWork: 'TCFD',
    reportPeriod: 'Q1 2022',
    reportStatus: 3,
    period: {
      label: 'Last Quarter',
      start: '2022-01-01',
      end: '2022-03-31'
    },
    introduction: {
      body:
        '<h4><strong>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</strong></h4><p><br></p><p>Mel te maiorum forensibus, odio ubique oblique vim et, enim debet cum ex. Vel melius necessitatibus et, ex ius modo doctus. Brute autem patrioque pro ea. Possit vocibus probatus mel ut, his ea causae epicuri. No harum tibique convenire sea. Decore dolores cu vix, ludus primis eu nam, agam esse ut pro. Eos ex postea torquatos, id nam dicunt reprehendunt.</p><p><br></p><ul><li>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei dictas aliquam salutatus.</li></ul><p><br></p><ul><li><em>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</em></li></ul><p><br></p><ul><li><em>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</em></li></ul><p><br></p><p><u>Lorem ipsum dolor sit amet, eos cu laudem iudicabit interesset. Eum cu illud mundi maiorum, ne dico voluptua vis. Nam at nisl latine. An his luptatum tacimates, vel dicit phaedrum ad. Est te mandamus consequat vituperatoribus.</u></p><p><br></p><p>Vix prompta eleifend ex, pri fuisset scaevola an, commodo lucilius sed an. Enim debitis ad sit, ex his error numquam sanctus, ius ne facilis omnesque facilisis. At sit solet quodsi intellegat. Has et dolorum delectus prodesset, deserunt perpetua et his. Est ei <strong><em><u>dictas aliquam salutatus.</u></em></strong></p><p><br></p><ol><li>Noster accusam eleifend sit te. Est dictas legendos laboramus ut, sed zril sapientem ad, alia illum duo ne. Ei harum eligendi vel, efficiendi scriptorem duo eu. Et vero tamquam quo. Dicant vocent sed an.</li></ol><p><br></p><ol><li>Te qui primis indoctum, ea eleifend suscipiantur mel. At usu nobis omnium, sumo admodum suscipiantur an vel. Te cibo omnis constituam usu, et ius legimus quaestio temporibus. Quo ex graece tempor.</li></ol>',
      reviewComments: [
        {
          reviewer: 0,
          body:
            '<p>There are some typos on line 3. Please correct them. Do not go into too much detail. Try to keep it simple.</P>',
          date: '10 Jul 2022 12:20 PM'
        },
        {
          reviewer: 0,
          body: '<p>Good job overall !</P>',
          date: '12 Jul 2022 09:10 AM'
        }
      ]
    },
    topics: [
      'a698f8a6-2597-4a9e-9d44-ee5cb5e27689',
      '8ace3c40-34a2-45bc-96a4-657d03cec235',
      '34aa1b04-2c38-4fe8-acb8-538a44156949'
    ],
    standards: [
      '397f4474-8270-4aad-afb4-f2ddea3a163c',
      'ae378063-bcb2-4248-8c27-61d76776cc64'
    ],
    requirements: [
      {
        key: '67aaeac0-d560-4816-b0c9-921aeb4e9e67',
        value: 'experienz'
      },
      {
        key: '99c31953-506a-4522-9d8e-17565c5dab89',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p>'
      },
      {
        key: '470f3049-5857-4be1-94f1-c8119d38af60',
        value: '<p>England, Sri Lanka, USA, Australia</p>'
      },
      {
        key: '5106e820-c639-4d0f-83f9-0bdae5fd28a6',
        value: '<p>London, UK</p>'
      },
      {
        key: '2295a0a8-1da5-4cb3-b497-d4d3a7788a4e',
        value:
          '<p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '7ef58cda-c7f4-4ed6-88e8-16e9fd49995c',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: 'f91fb6cf-d985-465c-9472-a5b00209ec87',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '4fb96f49-ca72-4e3e-939c-2489eb7467b0',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '62d29f51-3ac9-4115-862d-5a12bcbfb877',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '11faa601-eba6-4218-84da-ed30f8397362',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      },
      {
        key: '486f7e0b-70be-4b62-a1ea-3b4e71d078d8',
        value:
          '<p>Lorem ipsum dolor sit amet, id idque singulis scribentur nam. At noster euismod recusabo eos. Vide dolores expetendis mel ut. Ne mei alterum molestie quaerendum, exerci aperiri in duo, no vel scaevola urbanitas. Vix te integre aliquando, ei everti recusabo ius.</p><p><br></p><p>Ut unum malorum sit. Eum ei tantas perpetua. Omittam explicari ad eum, sea te percipit lobortis, te cum labitur platonem. Ne cum exerci atomorum, qui et meis dolor. Per amet legere patrioque ei, nemore dignissim eloquentiam usu an. An suscipit recteque disputationi mei.</p>'
      }
    ],
    modifiedRequirements: [
      '67aaeac0-d560-4816-b0c9-921aeb4e9e67',
      '470f3049-5857-4be1-94f1-c8119d38af60'
    ],
    reviewComments: [
      {
        reviewer: 0,
        body:
          '<p><strong>GRI 2-1 a  </strong>For the legal name, change it to experienz Ltd.</P> <p><strong>GRI 2-1 b  </strong>Please include more detail.</p> <p><strong>GRI 2-1 d  </strong>Add Singappore as a country of operation.</p>',
        date: '20 Aug 2022 03:20 PM'
      }
    ],
    reviewers: [
      {
        id: 2,
        name: 'Ashton Lewis'
      }
    ]
  }
];

const FRAMEWORKS = [
  {
    id: 1,
    name: 'GRI Standards',
    fullName: 'Global Reporting Initiative',
    version: 1.0,
    description:
      'A framework to help public companies and other organizations more effectively disclose climate-related risks and opportunities through their existing reporting processes',
    logoUrl:
      'data:image/png;base64,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'
  },
  {
    id: 2,
    name: 'TCFD',
    fullName: 'Task Force on Climate Related Financial Disclosures',
    version: 1.0,
    description:
      'A framework to help public companies and other organizations more effectively disclose climate-related risks and opportunities through their existing reporting processes',
    logoUrl:
      'https://media-exp1.licdn.com/dms/image/C4D0BAQEGJDZlwtGG2w/company-logo_200_200/0/1620249687099?e=2147483647&v=beta&t=nQSc6smIPvkaNxRuwgQZmAEqFZG7Nbjp_gZuAEhS9ZU'
  },
  {
    id: 3,
    name: 'UK Corporate Governance Code',
    fullName: 'UK Corporate Governance Code',
    version: 1.0,
    description:
      'All companies with a Premium Listing of equity shares in the UK are required under the Listing Rules to report in their annual report and accounts on how they have applied the Code.',
    logoUrl:
      'https://test-experienz-media.s3.eu-west-2.amazonaws.com/test/FRC.png'
  },
  {
    id: 4,
    name: 'Experienz Summary',
    fullName: 'Experienz Summary',
    version: 1.0,
    description:
      'A framework to help public companies and other organizations more effectively disclose climate-related risks and opportunities through their existing reporting processes',
    logoUrl:
      'https://experienz.co.uk/wp-content/uploads/2021/07/EX_EMB_DISC_OL_PETROL_RGB@2x.png'
  }
];

const imageToBase64 = async (url) => {
  const base64Image = await getBase64FromUrl(url);

  return base64Image;
};

const chartImage = imageToBase64(
  'https://test-experienz-media.s3.eu-west-2.amazonaws.com/experienz/news/Emissions+by+the+scopes+16+August+2022.jpeg'
);

const FRAMEWORK_MANIFEST = {
  topics: [
    {
      name: 'Universal',
      uuid: 'a698f8a6-2597-4a9e-9d44-ee5cb5e27689',
      description:
        'Incorporate reporting on human rights and environmental due diligence, in line with intergovernmental expectations',
      imageUrl:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAhFBMVEURWKb///8AU6QATqIAR58ASaAAS6EAVKT0+Pvf6PIAUaPz9fkATaJiiL0ARp8LVqXQ2Oja4++tv9pvksLs8ffJ1efC0ORTfri3x98kYqsTW6iOp82XrtHl7PR+msads9RJd7U5bbAxZ61ojL+luNaDn8l8l8Rdhby8y+FMebZAcbKcsNIJ0IJoAAAN1klEQVR4nN2d63qiMBCGA4FEIzWK9YCorafatfd/fwsqkEASAhIFvmef/dFa5TWnyWRmAizjGk0X/ibcHZfX/SFYg/U6OFyXx5/wazWffpr/eGDyzaer8HKgrutBQgjGFIDoX/wfxdgm0POQt77OvhZbkw9hinDo7w5jFxKb3qDkwjZErvfvvDKFaYJwerpQ17NL0FhRTKAbzFYmOm3ThJ/+BTvQ1odjMIk3PpwnDT9Qs4Tb0zeqR5dRIjz7HTT5UM0RDvxvB+Jn8B4iyDsuGnusxggXF9drAu8maiNyHjb0ZI0QjjaB+1TnFEAS57pq4tmaIJwcx7DCvKkt7MFw1ALC+bdDDODdRCHcPb2APEm4ODiNjT4hI3FmT5oCTxHO965RvpsIOj7F+ATh5PoCvli28/PEeKxNuL2Y7Z+ciLd5OWHoGptfRKKQ/r6U8JcaWR+UjO6/esOxDuHo4ryaL5Zdr6vWIPTRSztoJgqD6QsIR0v3HQ14F3ZD44Qr+KYGfMg7VLXIKxIe3zICWWH3ZJBwGLy3AW+i7sUYof8iG6ZMZF1lwqlAuHt7D01EHd8A4eAbvhssE3V2jRMO1y0YgozgsmHC+QvNbD2RQHNvrEfot2YIZsJUb2XUIvwbvxtHJOxpeY91CEP33TASOfNmCHdtBYymVI1NYznhD3o3iFx0XO5TLSVsM2DciqWIZYS7VgPGrVjWUUsIWzvJpKJOyYyqJty0HjCSq7bDlYR+K9fBvChRWjcqwrnz7ofXE16rjlQVhMM3OmSqiexrEQ7WbTO25YLHOoTXhs88jQrJfXBSwp8WbXg1JF8WZYR+R2aZRNST+fwlhN2ZZRLhfTXCoDuzTCI4q0J4bJdTRk+SrZSQcNWxQfgQFNo2IsJPr2uD8C77W5dw2aWVkBX60iP0W74llIu6AvdbkXDQuYUiE77qEF66OI8mQsWjtwLhopvz6EOUFCJvCoSgu300lv1RRhh2y+AuquC2yRF+dniauQsf1IQfXZ5m7kK+inDS6WnmIaoi/O7elqIouJETLrrgHi0VhQMp4b4PTRg1YigjXHTWIOVFyUBC2JMmzDUiQzjvxSiMRb2BkHDZlybkp9OMcNqbJgTcmpgRzrq6sxfJ84uEg06cpOmKBkXCr65vKnhlW4yUMOj6poIXmeUJ+7NU3JWZbgnhsU/zTKx0rnkQdtnBJlZ6UvMg9Ps1z8RythxhLzaGvEjIEn72YW+fU7Ikgr520qibThnCf/3rpKn5fSMcee9+GhN6+BVvhKteEgJ3mxL2brm/C55Swtes9phAhJB7K8jzknF/P8OICafm1wpKXHoJ/fl0OJxOVqfz1UNE8b1iWySs+F6yv8heRO2E0PjGyUZBmAsCHSxmRFoqBC8/RFp+ryESF/bBl/RVl+wFt8jTmNCwg8Z2PsRhvKurJBPHleY0jxYzKEqydpjXZN8B/HsQYpPjELszeYDrfI9Eny06js90Whf7nJMdjA6y7o+Xd8Khya0h3KtjlH0imMfVhJYVFtpeTAjAndA3uBo6pZnJg0vR015GaE3zmXQSwri7R4Q7Y6shJjppO5txvqeWElqDK48oIYSrG6ExZ7590Eug+80Pk3JCy+IRJYTkfCM05UYkB92aXfmDWR3CwZpteQkh/o4JTfm6sTZghMhH0ukQWlN2/EoIKYwJV2bWe2pXqSnzy3UkLULrzDy4bC51thHhxkxwgiCTZR4uA2Cv95dN8XchO6HrEVoMiowQzSPCi5GptBAmuD3biES2BaXYhm7wle/CV2a+YwlPfqrf3BfDWJsywmh7AayDkUpkuRC6wYyvCEahl1spt8xswxKOPZjIc9dc2NooM4hkhGQXEZaV36wlxPezlVcYChTmKiNsshZhCTkrlKJ/7J9k3U9GGNltYGRiKiV8QYBzYU2/fXouOzKLqJMSRt2OLYpxSr8UGSE9WMDEYkERN48eJREQdMx1uszhpyAE7NeSLRgyQkAtsDBglZIf9skVaah8pkva51SEbF5FduYpJUQjYMJVyq0Uquwbyu0Ew2SwqgjBmDEFU0NBSuhOwV/zyyGXvqKOduRemm7jlISI2U4HpYRoDs7NE0J2LSyJduQiCZM9gDbhoZTQW4Bd84TsA05L7HrmwN1KzSslocP8cp3+UEYIV+Cj8b0TXTMPXRrhgZjJZviYk1SElI3iKp9p4Ak0f2RhMwmdg/LafCS1WaDOTMNG42d2kJSQhGDfuEnDDkOdYECaKvmJgpCwQc6/pSs+sM/g8DxSTh7T7+rNY3JCGLAW+yx9dxVh81EmiFkN67liWULXJqm88dlilb25vJfuTBAyq/i61ruzhMdZqvOK33IxTkJ5G/6AdfEDnhRLWKW4fibNHTDTOHLC2bM4oudjCFXHL4p30CI8MRa1lBAfTbQh83z13kGL8JOdg1RtGDxFIxI70xzEMw1BQiWNokXIuj04Qjs3DpufaTym7P+H0KQh4USoZCenQ/jB7Ynkc+mPgfUQMsb0Rrg3g5KyhwNHm/DIv7Fqtbg23oasC2Mi9CBASQnSkS5hoYijnPAMmj8exWxKtTCd8dk2/KX5zi8n3JjYW0DmYYT5jM8RDr+LHUO1t/hp3iGMmDM14RZf1ks1CQVFHFX7w7D5HTBhrUdRI1YhDG/ibmXZFJ1nqj2+iUAMLgNQUKqoSi8dx7dhQT4drbjCyf00E2Ai4guxX/m02KmqzKV3y4VwhUuKJbqkhM4WzA0QYs73viq4aqq04cM24xOYC2FqKn+pkUgMhzuS+Mo79fHH3yZSmK95qCDkE5hH+SAVKSGwwMhE0iG3JEatmC+TjeOxNS6UIlEQAu+PfWW+dof0ZGZvgZrmf4kQ3zzDQyEyCI+LNx2oCClffSYXXiElvESEZkIxSO4E9LRGTOgVJc4/wZqnIgSEK8We88NKzw/PEaGZ4FJSqBG3+vYQJHZ88SGCR2Gkm5IQONyiuNOJNonnNCAx/5+WoMD/YH7afVyOZ19Wj1NNyHmac0GxMkJ3EhH+Ggr6GuvEQ1UhzOVor9hFQEY4/owIh4biZ6lX+UKREsI0Deauf8zwksXT2LeYKFN1ryisilhGyFsSbGyDLCbqciM0lhFEkVZHzRqmjBC43CIUlkabxJlBoK7nXQtxLCq+ldMpuwOglDC3CGUWuIQwPmAAZrMt0L+y8MTZOKsKpEHIBXnMy07X0D2+dGsyRth2lc04CaBdhRCMubGduvLEhLfj1/i8sd7hgqYoXEuLim9nDmaPGzUI+RKXo4RG7C+97bliQsMpMxStv0R9dTJz4g8WtCGSE+bqlSUxQ2LC2y4tJjSem0ehu/ziutdgEgbJ1V80ywahhZ8Uj3ZsNt0kceVRW/QXtyP/mHD7gmIDGLrkexae/JX/t7scXDZlpngITIs/AoKXl/zF3cy7nfu/JhefRrtCGEca2kYTPDLZs5TQQMRJG+StUsK+FBfi9ahScyPUiAnpoB5W7D3+xkwk9Jv18FneCXuZJvvYa90JBx2tHKxS4u97RImJz2o7rcSx/iDs4WyaGHJJpF+9sJAWCyfbzoTQ3Db4TUqjOhNCU/6odylzPabxqNd+lcYgYYGwZ0vieFsgLAZUd1k4c29lhAYO9N8ndy4g7OqNCCKx3hwm8r1HhRPZLA6GcNibyoncKRWbvdCbPRQX68ES9qaCKRfPw9WC7skOg8u74gn7Ybrlzor5muy9mE5zhfV5wu5fjVC8HCF3N0Lnr7fIh2wUb/Awkrv+Stn5S9fzhKuuuzOcfI2pwj0zHd8nwkJRowJh9+4FZJVbKYSE3Z5sxgsNQrOH3mZVjKYTEnb3shkKBGWNRHfnnbvaTwV9VHLDoyTjrO0S39MpJHxBMUwDwoGIRXIP6VcX131HHCgouUt22T3Hm/ACSzmhKNOl3SJ5e7SMUJDp0mrJb5CX3svdrRtzqbyoq/xu9V2XDjIktx2rCbs02yguj1cRdudybigwR7UIP18Uf/asxHc56xCarTDcmCS2jBahNRcWy2uXMFaHkqsJrUXrl0VqS9cJLUJr1fJWpLCsOkEZYbTytxlRI/WolNDyW9yKOrlV5YQtbkVMNDKrNAhbexk5xiWTjDahNZHe0/BO2YFWQXQtQmsI2nfsBq/lz61PaI0ObTPDkcoWrUFoWYIrDN4oWn7pQmVCSbnj9wi70myxJwiLlRHeJrLWK1lXldAaBu0YjGipfydBNULLOrZg8cfOX/mD1ia0/Lf3VBhUzBCvSGht928NYaRj4dlEk4SWtXljMxJQvVBDdUJrKL6kybyiBqwyxdQntKwv7w1GHIVB9QasS2h9Ll8+qRJX24ppgjDaUQUvteKwc9G7Wak5Qss62S+L7qdoX6uDPkloWaHyDsPmpKhZYJjQGp2FV/U1KgqpRvkQU4QRY+gZZcRoLanP9ypCyxpsgDErB7v7Z/pnQ4SR/MCpV7dbKUrGy/rzS6YmCC1rOoOwWVsOI3DW8aSVqxnCqLP6V6exEYk9Zyk/1K2opggjbTcH5/mWpBg6S7+G/SlTg4SRhn9713tiTFLieUu/rvUiVrOEkbb+0XbrNCW1obOe/TbYenc1Thhr+rcEyCPah+Q0vtB6fTxV8C/pywhhrO3v+Z89vtWCVKDd2MZkeV4ZoYtljPCm0cQPP/Zr6CAPRqwkvlsbx1WQ4uLHyEX0sDyfJs2Ou7zMEj402E4Wq6/wvPuZHS/H4+znHG783/m0yj2etfUfjtrQwvpPSkoAAAAASUVORK5CYII=',
      standards: [
        {
          id: '1',
          uuid: '397f4474-8270-4aad-afb4-f2ddea3a163c',
          name: 'GRI 2: General Disclosures',
          disclosures: [
            {
              id: '2-1',
              name: 'GRI 2-1: Organisational details',
              requirements: [
                {
                  id: '2-1-a',
                  uuid: '67aaeac0-d560-4816-b0c9-921aeb4e9e67',
                  name: "a. Report it's legal name",
                  guidance:
                    'Guidance to 2-1-a If the organization uses a commonly known trading name or business name that is different from its legal name, it should report this in addition to its legal name.',
                  dataType: 'text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  prefilledValues: 'Mitra Innovation',
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '2-1-b',
                  uuid: '99c31953-506a-4522-9d8e-17565c5dab89',
                  name: "b. Report it's nature of ownership and legal form",
                  guidance:
                    'Guidance to 2-1-b The nature of ownership and the legal form of the organization refers to whether it is publicly or privately owned, and whether it is an incorporated entity, a partnership, a sole proprietorship, or another type of entity such as a nonprofit, an association, or a charity.',
                  dataType: 'chart',
                  prefilledValues:
                    'https://test-experienz-media.s3.eu-west-2.amazonaws.com/experienz/news/Emissions+by+the+scopes+16+August+2022.jpeg',
                  rules: {},
                  source: {
                    id: 'cube-chart',
                    selector:
                      '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
                  }
                },
                {
                  id: '2-1-c',
                  uuid: '5106e820-c639-4d0f-83f9-0bdae5fd28a6',
                  name: "c. Report the location of it's headquarters",
                  guidance:
                    'Guidance to 2-1-c Headquarters are an organization’s global administrative center, the place from which it is controlled or directed.',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: 'cube-table',
                    selector:
                      '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
                  }
                },
                {
                  id: '2-1-d',
                  uuid: '470f3049-5857-4be1-94f1-c8119d38af60',
                  name: 'd. Report its countries of operation.',
                  guidance:
                    'Guidance to 2-1-d If the organization has reported its countries of operation elsewhere, such as in its audited consolidated financial statements or financial information filed on public record, the organization can provide a link or reference to this information. The organization can also report the regions or specific locations within countries (e.g., states, cities) where it has operations, if this provides contextual information for understanding the organization’s impacts.',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: '...'
                  }
                }
              ]
            },
            {
              id: '2-2',
              name:
                'GRI 2-2: Entities included in the organization’s sustainability reporting',
              requirements: [
                {
                  id: '2-2-a',
                  uuid: '2295a0a8-1da5-4cb3-b497-d4d3a7788a4e',
                  name:
                    'a. List all its entities included in its sustainability reporting ',
                  guidance:
                    'Guidance to 2-2-a The entities reported under 2-2-a form the basis for reporting the disclosures in this Standard and for determining the organization’s material topics. Requirement 2-2-a includes those entities that the organization controls or has an interest in and are included in its sustainability reporting, such as subsidiaries, joint ventures, and affiliates, including minority interests. The organization should report information for the same group of entities as covered in its financial reporting. When determining its material topics, the organization should consider the impacts of additional entities with which it has business relationships that are not included in the list reported under 2-2-a. See section 1 in GRI 3: Material Topics 2021 for more information.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '2-2-b',
                  uuid: '7ef58cda-c7f4-4ed6-88e8-16e9fd49995c',
                  name:
                    'b. If the organization has audited consolidated financial statements or financial information filed on public record, specify the differences between the list of entities included in its financial reporting and the list included in its sustainability reporting',
                  guidance:
                    'Guidance to 2-2-a and 2-2-b If all the entities in the organization’s financial reporting are also included in its sustainability reporting, a brief statement of this fact, including a link or reference to the list of entities included in its audited consolidated financial statements or financial information filed on public record, is sufficient to comply with 2-2-a and 2-2-b. The organization should separately specify any additional entities included in the sustainability reporting that are not included in its financial reporting.',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: 'cube-chart',
                    selector:
                      '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
                  }
                },
                {
                  id: '2-2-c',
                  uuid: 'f91fb6cf-d985-465c-9472-a5b00209ec87',
                  name:
                    ' c. If the organization consists of multiple entities, explain the approach used for consolidating the information',
                  guidance:
                    'Guidance to 2-2-c A minority interest is an ownership interest in an entity that is not controlled by the parent entity.',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: 'cube-table',
                    selector:
                      '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
                  }
                }
              ]
            },
            {
              id: '2-3',
              name: 'GRI 2-3: Reporting period, frequency and contact point',
              requirements: [
                {
                  id: '2-3-a',
                  uuid: '4fb96f49-ca72-4e3e-939c-2489eb7467b0',
                  name:
                    'a. Specify the reporting period for, and the frequency of, its sustainability reporting',
                  guidance:
                    'Guidance to 2-3-a The organization can specify the frequency of sustainability reporting as ‘annual’. See the Timeliness principle in GRI 1: Foundation 2021 for more information.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '2-3-b',
                  uuid: '62d29f51-3ac9-4115-862d-5a12bcbfb877',
                  name:
                    'b. Specify the reporting period for its financial reporting and, if it does not align with the period for its sustainability reporting, explain the reason for this',
                  guidance:
                    'Guidance to 2-3-a and 2-3-b The reporting period refers to the time period covered by the reported information and should include the start and end dates (e.g., 1 January 2022 to 31 December 2022, 1 July 2022 through 30 June 2023). The organization should report the information for the same reporting period as covered in its financial reporting. The organization should also publish the information at the same time as its financial reporting, where this is possible.',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: 'cube-chart',
                    selector:
                      '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
                  }
                },
                {
                  id: '2-3-c',
                  uuid: '11faa601-eba6-4218-84da-ed30f8397362',
                  name:
                    'c. Report the publication date of the report or reported information',
                  guidance: '',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: 'cube-table',
                    selector:
                      '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
                  }
                },
                {
                  id: '2-3-d',
                  uuid: '486f7e0b-70be-4b62-a1ea-3b4e71d078d8',
                  name:
                    'd. Specify the contact point for questions about the report or reported information',
                  guidance: '',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: '...'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Environment',
      uuid: '8ace3c40-34a2-45bc-96a4-657d03cec235',
      description:
        'Environmental dimension of sustainability concerns of the organisation’s impacts on living and non-living natural systems, including land, air, water and ecosystems.',
      imageUrl:
        'data:image/png;base64,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',
      standards: [
        {
          id: '2',
          uuid: 'ae378063-bcb2-4248-8c27-61d76776cc64',
          name: 'GRI 301: Materials',
          disclosures: [
            {
              id: '301-1',
              name: 'GRI 301-1: Materials used by weight or volume',
              requirements: [
                {
                  id: '301-1-a',
                  uuid: '81a88939-d476-4201-92da-76d2328e6ae1',
                  name:
                    'a. Total weight or volume of materials that are used to produce and package the organization’s primary products and services during the reporting period',
                  guidance:
                    'The reported usage data are to reflect the material in its original state, and not to be presented with further data manipulation, such as reporting it as ‘dry weight’.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                }
              ]
            },
            {
              id: '301-2',
              name: 'GRI 301-2: Recycled input materials used',
              requirements: [
                {
                  id: '301-2-a',
                  uuid: '9a3a448f-4ade-4443-9689-f79513e026c0',
                  name:
                    "a. Percentage of recycled input materials used to manufacture the organization's primary products and services.",
                  guidance:
                    'If material weight and volume measurements are stated as different units, the organization can convert measurements to standardized units.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                }
              ]
            },
            {
              id: '301-3',
              name:
                'GRI 301-3: Reclaimed products and their packaging materials',
              requirements: [
                {
                  id: '301-3-a',
                  uuid: '5797d9f1-f03d-497f-b36d-871d66e6b1d3',
                  name:
                    'a. Percentage of reclaimed products and their packaging materials for each product category.',
                  guidance:
                    'The reporting organization can also report recycling or reuse of packaging separately.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '301-3-b',
                  uuid: 'fc57f1b9-bf0c-4aa1-bd0e-dbe2f8a82dbe',
                  name:
                    'b. How the data for this disclosure have been collected.',
                  guidance:
                    'The reporting organization can also report recycling or reuse of packaging separately.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                }
              ]
            }
          ]
        },
        {
          id: '3',
          uuid: '7a1aab6a-7a75-4997-8e15-5eb4aa18217b',
          name: 'GRI 302: Energy',
          disclosures: [
            {
              id: '302-1',
              name: 'GRI 302-1: Energy consumption within the organization',
              requirements: [
                {
                  id: '302-1-a',
                  uuid: 'b664d91a-121b-43d0-aaec-55a24fad3e7e',
                  name:
                    'a. Total fuel consumption within the organization from non-renewable sources, in joules or multiples, and including fuel types used.',
                  guidance:
                    'For some organizations, electricity is the only significant form of energy they consume. For others, energy sources such as steam or water provided from a district heating plant or chilled water plant can also be important. Energy can be purchased from sources external to the organization or produced by the organization itself (self-generated). Non-renewable fuel sources can include fuel for combustion in boilers, furnaces, heaters, turbines, flares, incinerators, generators and vehicles that are owned or controlled by the organization. Non-renewable fuel sources cover fuels purchased by the organization. They also include fuel generated by the organization’s activities – such as mined coal, or gas from oil and gas extraction. Renewable fuel sources can include biofuels, when purchased for direct use, and biomass in sources owned or controlled by the organization. Consuming non-renewable fuels is usually the main contributor to direct (Scope 1) GHG emissions, which are reported in Disclosure 305-1 of GRI 305: Emissions 2016. Consuming purchased electricity, heating, cooling, and steam contributes to the organization’s energy indirect (Scope 2) GHG emissions, which are reported in Disclosure 305-2 of GRI 305: Emissions 2016.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '302-1-b',
                  uuid: 'd0fb02f7-c212-4e8d-a71f-8751624687fc',
                  name:
                    'b. Total fuel consumption within the organization from renewable sources, in joules or multiples, and including fuel types used.',
                  guidance:
                    'For some organizations, electricity is the only significant form of energy they consume. For others, energy sources such as steam or water provided from a district heating plant or chilled water plant can also be important. Energy can be purchased from sources external to the organization or produced by the organization itself (self-generated). Non-renewable fuel sources can include fuel for combustion in boilers, furnaces, heaters, turbines, flares, incinerators, generators and vehicles that are owned or controlled by the organization. Non-renewable fuel sources cover fuels purchased by the organization. They also include fuel generated by the organization’s activities – such as mined coal, or gas from oil and gas extraction. Renewable fuel sources can include biofuels, when purchased for direct use, and biomass in sources owned or controlled by the organization. Consuming non-renewable fuels is usually the main contributor to direct (Scope 1) GHG emissions, which are reported in Disclosure 305-1 of GRI 305: Emissions 2016. Consuming purchased electricity, heating, cooling, and steam contributes to the organization’s energy indirect (Scope 2) GHG emissions, which are reported in Disclosure 305-2 of GRI 305: Emissions 2016.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                }
              ]
            },
            {
              id: '302-2',
              name: 'GRI 302-2: Energy consumption outside of the organization',
              requirements: [
                {
                  id: '302-2-a',
                  uuid: '19de44b7-c64f-4047-95cb-48909b356c09',
                  name:
                    'a. Energy consumption outside of the organization, in joules or multiples.',
                  guidance:
                    'The reporting organization can identify energy consumption outside of the organization by assessing whether an activity’s energy consumption:',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '302-2-b',
                  uuid: '1e318cab-f8e8-4b20-8c7c-831e0f2b434a',
                  name:
                    'b. Standards, methodologies, assumptions, and/or calculation tools used.',
                  guidance:
                    'The reporting organization can identify energy consumption outside of the organization by assessing whether an activity’s energy consumption:',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '302-2-c',
                  uuid: '8f18e3f8-cb39-4fa4-9a65-045c163ac63c',
                  name: 'c. Source of the conversion factors used.',
                  guidance:
                    'The reporting organization can identify energy consumption outside of the organization by assessing whether an activity’s energy consumption:',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Social',
      uuid: '34aa1b04-2c38-4fe8-acb8-538a44156949',
      description:
        'Social dimension of sustainability concerns of the organisation’s impacts on the social systems within which it operates.',
      imageUrl:
        'data:image/png;base64,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',
      standards: [
        {
          id: '4',
          uuid: '8e24ff0c-676b-4afb-aeec-c3519d2d588d',
          name: 'GRI 401: Employment',
          disclosures: [
            {
              id: '401-1',
              name: 'GRI 401-1: New employee hires and employee turnover',
              requirements: [
                {
                  id: '301-1-a',
                  uuid: '72569e13-e22e-4826-b8a3-f24f94a17153',
                  name:
                    'a. Total number and rate of new employee hires during the reporting period, by age group, gender and region.',
                  guidance:
                    'The number, age, gender, and region of an organization’s new employee hires can indicate its strategy and ability to attract diverse, qualified employees. This information can signify the organization’s efforts to implement inclusive recruitment practices based on age and gender. It can also signify the optimal use of available labor and talent in different regions.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '301-1-b',
                  uuid: '57062e18-3248-46ed-88c9-3f25cce50cc5',
                  name:
                    'b. Total number and rate of employee turnover during the reporting period, by age group, gender and region.',
                  guidance:
                    'The number, age, gender, and region of an organization’s new employee hires can indicate its strategy and ability to attract diverse, qualified employees. This information can signify the organization’s efforts to implement inclusive recruitment practices based on age and gender. It can also signify the optimal use of available labor and talent in different regions.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                }
              ]
            },
            {
              id: '401-2',
              name:
                'GRI 401-2: Benefits provided to full-time employees that are not provided to temporary or part-time employees',
              requirements: [
                {
                  id: '401-2-a',
                  uuid: '25bf3fd0-1c75-4b34-8554-1db5dc0a31f8',
                  name:
                    'a. Benefits which are standard for full-time employees of the organization but are not provided to temporary or part-time employees, by significant locations of operation.',
                  guidance:
                    'Data reported under this disclosure provide a measure of an organization’s investment in human resources and the minimum benefits it offers its full-time employees. The quality of benefits for full-time employees is a key factor in retaining employees.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '401-2-b',
                  uuid: 'd2fea328-b2d2-4ef5-8fa1-b6993dbf7591',
                  name:
                    'b. The definition used for ‘significant locations of operation’.',
                  guidance:
                    'Data reported under this disclosure provide a measure of an organization’s investment in human resources and the minimum benefits it offers its full-time employees. The quality of benefits for full-time employees is a key factor in retaining employees.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Economic',
      uuid: 'e18bfa94-0cb6-4ac6-b18d-8d5303a4504f',
      description:
        'Economic dimension of sustainability concerns of the organisation’s impacts on the economic conditions of its stakeholders, and on economic systems',
      imageUrl:
        'data:image/png;base64,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',
      standards: []
    }
  ]
};

const FRAMEWORK_MANIFEST_ = {
  topics: [
    {
      name: 'Universal',
      uuid: '0ac0db4b-b93e-466b-ac31-50438898dd91',
      description: 'Some description about Universal topic',
      imageUrl:
        'data:image/png;base64,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',
      standards: [
        {
          id: '1',
          uuid: 'b2f8d400-4140-41db-8c4e-bfc4ec400d13',
          name: 'GRI 2: General Disclosures',
          disclosures: [
            {
              id: '2-1',
              name: 'GRI 2-1: Organisational details',
              requirements: [
                {
                  id: '2-1-a',
                  uuid: '33ae8013-0081-44af-b287-abf0ebd313e2',
                  name: "a. Report it's legal name",
                  guidance:
                    'Guidance to 2-1-a If the organization uses a commonly known trading name or business name that is different from its legal name, it should report this in addition to its legal name.',
                  dataType: 'rich-text',
                  rules: {
                    minLength: 5,
                    maxLength: 10,
                    maxImageAttachments: 2
                  },
                  prefilledValues: '<p> Mitra Innovation </p>',
                  source: {
                    id: 'ssm',
                    selector: '/experienz/prod/${domain}/title'
                  }
                },
                {
                  id: '2-1-b',
                  uuid: 'ec5657c4-b11b-4958-9f23-45099f1b32ab',
                  name: "b. Report it's nature of ownership and legal form",
                  guidance: 'Guidance to 2-1-b ...',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'cube-chart',
                    selector:
                      '{"data":[],"query":{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]},"title":"CO2 Emissions(kgco2e)","unitType":"NUMBER","chartType":"pie","showLegend":false,"chartHeight":220,"showRefData":false,"titleEnabled":true}'
                  }
                },
                {
                  id: '2-1-c',
                  uuid: '87292515-8d53-4c31-ad8a-e169597205a2',
                  name: "c. Report the location of it's headquarters",
                  guidance: 'Guidance to 2-1-c ...',
                  dataType: 'rich-text',
                  rules: {},
                  prefilledValues: `<p><img src=${'https://test-experienz-media.s3.eu-west-2.amazonaws.com/experienz/news/Emissions+by+the+scopes+16+August+2022.jpeg'} /></p>`,
                  source: {
                    id: 'cube-table',
                    selector:
                      '{"order":{"esg.total":"desc"},"filters":[{"member":"esg.subCategory","values":["co2"],"operator":"equals"}],"measures":["esg.total"],"segments":["esg.emissions"],"dimensions":["esg.indicator"],"timeDimensions":[{"dimension":"esg.date"}]}'
                  }
                },
                {
                  id: '2-1-d',
                  uuid: 'b25bcdbc-e81b-4c97-ba2a-6df7b527a104',
                  name: 'd. report its countries of operation.',
                  guidance: 'Guidance to 2-1-d ...',
                  dataType: 'rich-text',
                  rules: {},
                  source: {
                    id: '...'
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Environment',
      uuid: '2aac9fc9-c4c6-4f3d-a9ba-9dae0281c067',
      description: 'Some description about Environment topic',
      imageUrl:
        'data:image/png;base64,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',
      standards: []
    },
    {
      name: 'Social',
      uuid: 'be25ae61-023b-4eff-bac9-910bc1eb1c92',
      description: 'Some description about Social topic',
      imageUrl:
        'data:image/png;base64,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',
      standards: []
    },
    {
      name: 'Economic',
      uuid: '62d88ccb-0c77-4194-a2e8-a358caf4a65b',
      description: 'Some description about Economic topic',
      imageUrl:
        'data:image/png;base64,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',
      standards: []
    }
  ]
};

const TCFD = {
  topics: [
    {
      name: 'Governance',
      uuid: '3adda970-d232-4f95-91fa-348879918cd7',
      description:
        'Disclose the organization’s governance around climate-related risks and opportunities.',
      imageUrl:
        'https://media-exp1.licdn.com/dms/image/C4D0BAQEGJDZlwtGG2w/company-logo_200_200/0/1620249687099?e=2147483647&v=beta&t=nQSc6smIPvkaNxRuwgQZmAEqFZG7Nbjp_gZuAEhS9ZU',
      standards: [
        {
          id: '1',
          uuid: '4d0f2d0e-1ecb-482b-b0ec-6aa78d9cbdc3',
          name: 'TCFD : Governance Disclosures',
          disclosures: [
            {
              id: '1-a',
              name:
                'a. Describe the board’s oversight of climate-related risks and opportunities',
              requirements: [
                {
                  id: '1-a-1',
                  uuid: '8a0d259c-06a4-438f-bb78-a90f9bfe4100',
                  name:
                    'Board’s oversight of climate-related risks and opportunities',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            },
            {
              id: '1-b',
              name:
                'b. Describe management’s role in assessing and managing climate-related risks and opportunities',
              requirements: [
                {
                  id: '1-b-1',
                  uuid: 'e894e7d5-73d5-4e6c-beda-a4ba5df4015d',
                  name:
                    'Management’s role in assessing and managing climate-related risks and opportunities',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Strategy',
      uuid: '410ee657-8fab-4af5-bbc3-48ef8d30fe41',
      description:
        'Disclose the actual and potential impacts of climate-related risks and opportunities on the organization’s businesses, strategy, and financial planning where such information is material.',
      imageUrl:
        'https://media-exp1.licdn.com/dms/image/C4D0BAQEGJDZlwtGG2w/company-logo_200_200/0/1620249687099?e=2147483647&v=beta&t=nQSc6smIPvkaNxRuwgQZmAEqFZG7Nbjp_gZuAEhS9ZU',
      standards: [
        {
          id: '2',
          uuid: '5e6f0d61-4913-4f99-9ca0-f9c4b7b418f1',
          name: 'TCFD : Risk and Metrics',
          disclosures: [
            {
              id: '2-a',
              name:
                'a. Describe the climate-related risks and opportunities the organisation has identified over the short, medium and long term',
              requirements: [
                {
                  id: '2-a-1',
                  uuid: 'c238d956-4cc5-40a2-b0a2-875525380910',
                  name:
                    'Impact of climate-related risks and opportunities on businesses, strategy and financial planning',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            },
            {
              id: '2-b',
              name:
                'b. Describe the impact of climate-related risks and opportunities on the organisation’s businesses, strategy and financial planning',
              requirements: [
                {
                  id: '2-b-1',
                  uuid: '3178de15-1065-4a48-92d2-26b04040b40d',
                  name:
                    'Impact of climate-related risks and opportunities on businesses, strategy and financial planning',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            },
            {
              id: '2-c',
              name:
                'c. Describe the resilience of the organisation’s strategy, taking into consideration different climate-related scenarios, including a 2°C or lower scenario',
              requirements: [
                {
                  id: '2-c-1',
                  uuid: 'fb26c7f2-32d8-4565-bfd9-de7b333c8bcc',
                  name:
                    'Resilience of the organisation’s strategy, taking into consideration different climate-related scenarios, including a 2°C or lower scenario',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Risk Management',
      uuid: '95d94886-a030-4343-801d-b42dd06c9f50',
      description:
        'Disclose how the organization identifies, assesses, and manages climate-related risks.',
      imageUrl:
        'https://media-exp1.licdn.com/dms/image/C4D0BAQEGJDZlwtGG2w/company-logo_200_200/0/1620249687099?e=2147483647&v=beta&t=nQSc6smIPvkaNxRuwgQZmAEqFZG7Nbjp_gZuAEhS9ZU',
      standards: [
        {
          id: '3',
          uuid: 'c9f13c18-4663-4294-b702-d7e008ed5b12',
          name: 'TCFD : Strategic Disclosures',
          disclosures: [
            {
              id: '3-a',
              name:
                'a. Describe the organisation’s processes for identifying and assessing climate-related risks',
              requirements: [
                {
                  id: '3-a-1',
                  uuid: '8b9e99a7-6133-4911-a68e-a2794f5b837e',
                  name:
                    'Processes for identifying and assessing climate-related risks',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            },
            {
              id: '3-b',
              name:
                'b. Describe the organisation’s processes for managing climate-related risks',
              requirements: [
                {
                  id: '3-b-1',
                  uuid: '76a1e3ef-4c10-4593-ba6e-5adb4d3a8382',
                  name: 'Processes for managing climate-related risks',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            },
            {
              id: '3-c',
              name:
                'c. Describe how processes for identifying, assessing and managing climate-related risks are integrated into the organisation’s overall risk management',
              requirements: [
                {
                  id: '3-c-1',
                  uuid: 'b42abeb1-f08a-4df8-86df-9ed56680b0f6',
                  name:
                    'Processes for identifying, assessing and managing climate-related risks are integrated into the overall risk management',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: 'Metrics and Targets',
      uuid: 'd8e957b6-d770-4d3d-a2d0-064112d9e416',
      description:
        'Disclose the metrics and targets used to assess and manage relevant climate-related risks and opportunities where such information is material.',
      imageUrl:
        'https://media-exp1.licdn.com/dms/image/C4D0BAQEGJDZlwtGG2w/company-logo_200_200/0/1620249687099?e=2147483647&v=beta&t=nQSc6smIPvkaNxRuwgQZmAEqFZG7Nbjp_gZuAEhS9ZU',
      standards: [
        {
          id: '4',
          uuid: '53d760bb-a28f-411a-a31c-761086a13ecd',
          name: 'TCFD : Strategic Disclosures',
          disclosures: [
            {
              id: '4-a',
              name:
                'a. Disclose the metrics used by the organisation to assess climate-related risks and opportunities in line with its strategy and risk management process',
              requirements: [
                {
                  id: '4-a-1',
                  uuid: '8b9a1eb9-d768-4a00-96e1-5a404b03882e',
                  name:
                    'Metrics used to assess climate-related risks and opportunities in line with its strategy and risk management process',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            },
            {
              id: '4-b',
              name:
                'b. Disclose Scope 1, Scope 2, and, if appropriate, Scope 3 greenhouse gas (GHG) emissions, and the related risks',
              requirements: [
                {
                  id: '4-b-1',
                  uuid: '0de84668-087e-41cc-8a51-42de0302d0fc',
                  name:
                    'Scope 1, Scope 2, and, if appropriate, Scope 3 greenhouse gas (GHG) emissions, and the related risks',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            },
            {
              id: '4-c',
              name:
                'c. Describe the targets used by the organisation to manage climate-related risks and opportunities and performance against targets',
              requirements: [
                {
                  id: '4-c-1',
                  uuid: 'dae1205a-3dce-4924-a9f7-7067083a6680',
                  name:
                    'Targets used to manage climate-related risks and opportunities and performance against targets',
                  guidance: '',
                  dataType: 'text',
                  rules: {},
                  source: {
                    id: 'text',
                    selector: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

const PREFILLED_VALUES = [
  {
    uuid: 'c238d956-4cc5-40a2-b0a2-875525380910',
    prefilledValue: '2000',
    prefilledUnit: ' kgCO2e',
    prefilledTrend: '-10%'
  },
  {
    uuid: '3178de15-1065-4a48-92d2-26b04040b40d',
    prefilledValue: '2000',
    prefilledUnit: ' kgCO2e',
    prefilledTrend: '-10%'
  },
  {
    uuid: '8b9e99a7-6133-4911-a68e-a2794f5b837e',
    prefilledValue: '2000',
    prefilledUnit: ' kgCO2e',
    prefilledTrend: '-10%'
  },
  {
    uuid: '76a1e3ef-4c10-4593-ba6e-5adb4d3a8382',
    prefilledValue: '2000',
    prefilledUnit: ' kgCO2e',
    prefilledTrend: '-10%'
  },
  {
    uuid: 'b42abeb1-f08a-4df8-86df-9ed56680b0f6',
    prefilledValue: '2000',
    prefilledUnit: ' kgCO2e',
    prefilledTrend: '-10%'
  },
  {
    uuid: '8b9a1eb9-d768-4a00-96e1-5a404b03882e',
    prefilledValue: '2000',
    prefilledUnit: ' kgCO2e',
    prefilledTrend: '-10%'
  }
];

const REPORT_REVIEWERS = [
  { id: 1, name: 'Jason Blake' },
  { id: 2, name: 'Ashton Lewis' },
  { id: 3, name: 'David Jenson' }
];

const pdfToBase64 = async () => {
  const base64 = await getBase64FromUrl(
    'https://test-experienz-media.s3.eu-west-2.amazonaws.com/shared/integrated-reports/ESG_Report.pdf'
  );
  return base64?.data;
};

let integratedReports = {
  data: [...INTEGRATED_REPORTS]
};

let frameworks = {
  data: [...FRAMEWORKS]
};

let frameworkManifest = {
  data: { ...TCFD }
};

let prefilledRequirements = {
  data: [...PREFILLED_VALUES]
};

let reportManifest = [...INTEGRATED_REPORT];

let reportReviewers = {
  data: [...REPORT_REVIEWERS]
};

mock
  .onGet(/^\/api\/intergrated-reports\/prefilled-requirements\/[^\/]+/)
  .reply(async () => {
    await fakeRequest(1000);
    try {
      return [200, { ...prefilledRequirements }];
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });

// ----------------------------------------------------------------------

mock
  .onPost(/^\/api\/intergrated-reports\/generatedReport\/[^\/]+/)
  .reply(async (request) => {
    const PREVIEW_REPORT_BASE64 = await pdfToBase64();
    let previewReport = {
      ...PREVIEW_REPORT_BASE64
    };
    await fakeRequest(1000);
    try {
      return [200, { ...{ data: PREVIEW_REPORT_BASE64 } }];
    } catch (error) {
      return [500, { message: 'Internal server error' }];
    }
  });

// ----------------------------------------------------------------------

mock.onGet('/api/intergrated-reports/reviewers').reply(async () => {
  await fakeRequest(1000);
  try {
    return [200, { ...reportReviewers }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock.onGet('/api/intergrated-reports/reports').reply(async (config) => {
  await fakeRequest(1000);
  try {
    return [200, { ...integratedReports }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock
  .onDelete(/^\/api\/intergrated-reports\/report\/[^\/]+/)
  .reply(async (request) => {
    await fakeRequest(1000);
    try {
      const reportId = request.url.split('/').slice(-1)[0];
      integratedReports.data = reject(integratedReports.data, { id: reportId });
      integratedReports.data = integratedReports.data.filter(
        (report) => report.id != reportId
      );
      return [200, { reportId }];
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });

// ----------------------------------------------------------------------

mock.onGet('api/intergrated-reports/frameworks').reply(async (config) => {
  await fakeRequest(1000);
  try {
    return [200, { ...frameworks }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock
  .onGet(/^\/api\/intergrated-reports\/framework-manifest\/[^\/]+/)
  .reply(async (request) => {
    await fakeRequest(1000);
    try {
      return [200, { ...frameworkManifest }];
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });

// ----------------------------------------------------------------------

mock
  .onGet(/^\/api\/intergrated-reports\/report\/[^\/]+/)
  .reply(async (request) => {
    await fakeRequest(1000);
    try {
      const reportId = Number(request.url.split('/').slice(-1)[0]);
      const integratedReport = reportManifest.find(
        (_report) => _report.id === reportId
      );
      if (!integratedReport) {
        return [
          404,
          { ...{ data: { message: 'Integrated report not found' } } }
        ];
      }
      return [200, { ...{ data: integratedReport } }];
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });

// ----------------------------------------------------------------------

mock.onPost('/api/integrated-reports').reply(async (request) => {
  await fakeRequest(1000);
  try {
    const { reportName, frameWork, reportPeriod, reportStatus } = JSON.parse(
      request.data
    );
    const integratedReport = {
      id: faker.datatype.number(),
      name: reportName,
      frameWork: frameWork,
      period: reportPeriod,
      createdBy: faker.name.firstName() + ' ' + faker.name.lastName(),
      status: reportStatus
    };

    integratedReports.data = [...integratedReports.data, integratedReport];

    return [200, { integratedReport: integratedReport }];
  } catch (error) {
    console.error(error);
    return [500, { message: 'Internal server error' }];
  }
});

// ----------------------------------------------------------------------

mock
  .onPut(/^\/api\/intergrated-reports\/report\/[^\/]+/)
  .reply(async (request) => {
    await fakeRequest(1000);
    try {
      const {
        id,
        reportName,
        frameWork,
        reportPeriod,
        reportStatus
      } = JSON.parse(request.data);
      const integratedReport = {
        id: id > 0 ? id : faker.datatype.number(),
        name: reportName,
        frameWork: frameWork,
        period: reportPeriod,
        createdBy:
          id > 0
            ? 'Jaydon Smith'
            : faker.name.firstName() + ' ' + faker.name.lastName(),
        status: reportStatus,
        isEditable: true
      };

      if (id > 0) {
        let index = integratedReports.data.indexOf(
          integratedReports.data.find(
            (report) => report.id == integratedReport.id
          )
        );

        integratedReports.data[index] = integratedReport;
      } else {
        integratedReports.data = [...integratedReports.data, integratedReport];
      }
      return [200, { data: [] }];
    } catch (error) {
      console.error(error);
      return [500, { message: 'Internal server error' }];
    }
  });
